module.exports = __webpack_public_path__ + "img/wari.99886b86.png";